import React, { useCallback, useEffect, useRef } from "react";
import {
  Button,
  FormFieldSet,
  Modal,
  showToast,
  SmartTooltip,
  useFormHandler,
} from "../../../../../../components";
import {
  EmployeeClassification,
  EmployeeStatus,
  EmploymentType,
  Gender,
} from "../../../../../../assets/data/enumData";
import {
  cityStateListOptions,
  WADocType,
} from "../../../../../../assets/data/projectData";

/////
import { useDispatch, useSelector } from "react-redux";
import { updateEmployee } from "../../../../../../redux/slices/employee/employeeApi";
import {
  getEmployeeByUiidStart,
  updateEmployeeStart,
} from "../../../../../../redux/slices/employee/employeeSlice";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";
//////

const EditGeneralDetailsModal = ({ editModal, setEditModal, edit }) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const containerRef = useRef(null);

  // Add state for UIID
  const loginUserUiid = loginUserData?.uiid;
  const organizationId = loginUserData?.organizationId.uiid;
  const { loading, error, employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const {
    firstName,
    middleName,
    lastName,
    jobTitle,
    email,
    mobile,
    alternateEmail,
    gender,
    uiid,
    employmentType,
    status,
    managers,
    joinDate,
    category,
    location,
    classification,
    workAuthorization,
    linkedTo,
  } = currentEmployee.employeeDetails || {};
  //console.log("currentEmployee", currentEmployee.employeeDetails);

  //
  const {
    data: jobTitleOptions,
    searchValue: jobTitlesSearch,
    handleSearch: handleJobTitlesSearch,
    resetSearch: resetJobTitlesSearch,
    handleScroll: handleJobTitlesScroll,
  } = useDropdownData("jobTitles");

  const {
    data: hmOptions,
    searchValue: hiringManagerSearch,
    handleSearch: handleHiringManagerSearch,
    resetSearch: resetHiringManagerSearch,
    handleScroll: handleHiringManagerScroll,
  } = useDropdownData("hiringManager", 5, {}, { orgId: organizationId });

  //

  const initialFormData = {
    firstName: firstName || "-",
    middleName: middleName || "-",
    lastName: lastName || "-",
    jobTitle: jobTitle,
    email: email?.primary,
    contactNumber: mobile?.primary?.number || "",
    countryCode: mobile?.primary?.code || "+1", // Remove String() wrapper
    alternateEmail: alternateEmail,
    gender: gender,
    employeId: uiid,
    employeeType: employmentType,
    employeeStatus: status,
    hrManager: managers?.HR,
    dateOfJoining: joinDate,
    category: category,
    location: location,
    classification: classification,
    workAuthorization: workAuthorization,
    linkedTo: linkedTo || 0,
  };
  const {
    formData,
    errors,
    handleChange,
    validateAllFields,
    setFormData,
    setErrors,
  } = useFormHandler(initialFormData, {
    firstName: { type: "text", required: true },
    lastName: { type: "text", required: true },
    email: { type: "email", required: true, email: true },
  });
  console.log("formData", formData);

  const handleSaveGeneralDetails = () => {
    const isValid = validateAllFields();

    if (isValid) {
      // console.log("Saving general details:", formData);
      // setEditModal(false);
      // return;
      const submissionData = {
        firstName: formData.firstName,
        middleName: formData.middleName,
        lastName: formData.lastName,
        jobTitle: formData.jobTitle,
        email: {
          primary: formData.email,
          secondary: formData.alternateEmail,
        },
        mobile: {
          primary: {
            code: formData.countryCode,
            number: formData.contactNumber,
          },
        },
        gender: formData.gender,
        employmentType: formData.employeeType,
        linkedTo: formData?.linkedTo?.uiid
          ? formData?.linkedTo?.uiid
          : formData?.linkedTo?.value
            ? formData?.linkedTo?.value
            : null,
        status: formData.employeeStatus,
        managers: {
          HR: formData.hrManager,
        },
        joinDate: formData.dateOfJoining,
        category: formData.category,
        // location: formData.location,
        // classification: formData.classification,
        workAuthorization: formData.workAuthorization,
      };
      console.log("submissionData", submissionData);
      // return;
      dispatch(
        updateEmployeeStart({
          coll: "Employee",
          uiid: employeeProfileUiid,
          payload: [
            {
              type: "SET",
              value: submissionData,
            },
          ],
          onSuccess: () => {
            dispatch(
              getEmployeeByUiidStart({
                uiid: employeeProfileUiid,
                tab: "generalEducation",
                ret: "firstName middleName lastName jobTitle status email mobile employmentType gender employmentType joinDate location category classification workAuthorization educationDetails managers ssn dob bloodType",
                ref: "EduDoc Parent",
                incl: ["", "firstName middleName lastName employmentType"],
              }),
            );
            handleModalClose();
          },
          tab: "generalEducation",
          ret: "firstName middleName lastName jobTitle status email mobile employmentType gender employmentType joinDate location category classification educationDetails managers",
        }),
      );
    } else {
      console.log("check before you submiting ");
      showToast("Please fill all the required feilds before saving","error", 3000)
    }
  };

  // Handle modal close with reset
  const resetForm = useCallback(() => {
    setFormData(initialFormData);
  }, [editModal, edit, setFormData]);

  // Initialize form when modal opens or edit status changes
  useEffect(() => {
    resetForm();
  }, [editModal, edit, resetForm]);

  const handleModalClose = () => {
    resetForm();
    setEditModal();
  };

  useEffect(() => {
    if (error) {
      showToast({
        message: error,
        type: "error",
      });
    }
  }, [error]);
  const handleDelink = async () => {
    const payrollFinalizeExists = await axiosRequest({
      method: "GET",
      url: ENDPOINTS.PAYROLL.GET_ALL,
      params: {
        coll: "Payroll",
        fil: JSON.stringify({
          employeeId: { type: "NONE", value: employeeProfileUiid },
          status: { type: "NONE", value: 2 },
        }),
        cache: false,
      },
    });
    console.log("payrollFinalizeExists", payrollFinalizeExists);
    if (payrollFinalizeExists?.success) {
      showToast("Payroll In Finalize State, Cannot be Unlinked", "error");
      return;
    } else {
      handleChange("linkedTo", null);
    }
  };
  return (
    <>
      <Modal
        isOpen={editModal}
        onClose={handleModalClose}
        title="Edit General Details"
        width="max-w-6xl"
      >
        <div>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 px-2 max-w-7xl">
            <FormFieldSet
              type="text"
              title="First Name"
              placeholder="Enter First Name"
              value={formData.firstName}
              onChange={(value) => handleChange("firstName", value)}
              error={errors.firstName}
            />
            <FormFieldSet
              type="text"
              title="Middle Name"
              placeholder="Enter Middle Name"
              value={formData.middleName}
              onChange={(value) => handleChange("middleName", value)}
              error={errors.middleName}
            />
            <FormFieldSet
              type="text"
              title="Last Name"
              placeholder="Enter Last Name"
              value={formData.lastName}
              onChange={(value) => handleChange("lastName", value)}
              error={errors.lastName}
            />
            {employmentType !== 4 && (
              <FormFieldSet
                type="select"
                title={"Job Title"}
                placeholder="Select Job Title"
                keyname={"jobTitles"}
                options={jobTitleOptions}
                value={formData.jobTitle}
                onChange={(value) => handleChange("jobTitle", value)}
                error={errors.jobTitle}
                showSearch
                searchValue={jobTitlesSearch}
                onSearch={handleJobTitlesSearch}
                onClose={resetJobTitlesSearch}
                showButton
                alertName={"addJobTitles"}
                icon={"add"}
                required
                handleScroll={() => handleJobTitlesScroll(containerRef)}
                refData={containerRef}
              />
            )}
            {employmentType === 4 && (
              <div className="flex gap-2">
                <div className={!!formData.linkedTo ? "w-[90%]" : "w-[100%]"}>
                  <FormFieldSet
                    type="employeesSortedWithoutRef"
                    title={"Linked To"}
                    placeholder="Select Linked To"
                    value={
                      formData.linkedTo?.label
                        ? formData?.linkedTo?.label
                        : formData?.linkedTo?.uiid
                          ? [
                              formData?.linkedTo?.firstName,
                              formData?.linkedTo?.lastName,
                            ]
                              .filter(Boolean)
                              .join(" ")
                          : ""
                    }
                    onChange={(value) => handleChange("linkedTo", value)}
                    error={errors.linkedTo}
                    showSearch
                  />
                </div>
                {!!formData.linkedTo && (
                  <div className="w-[10%] mt-6">
                    {/* <Button
                    type="icon"
                    variant="outlined"
                    icon={"delete"}
                    onClick={handleDelink}
                  /> */}
                    <SmartTooltip
                      noicon
                      description={"Delink"}
                      tooltipPosition={"right"}
                      variant="contained"
                    >
                      <Button
                        type="icon"
                        variant="outlined"
                        // icon={"delete"}
                        icon={"link_off"}
                        onClick={handleDelink}
                      />
                    </SmartTooltip>
                  </div>
                )}
              </div>
            )}
            <FormFieldSet
              type="text"
              title="Email Address"
              placeholder="Enter Email Address"
              value={formData.email}
              onChange={(value) => handleChange("email", value)}
              error={errors.email}
            />

            <FormFieldSet
              type="phone"
              title="Contact Number"
              placeholder="Enter Contact"
              value={formData.contactNumber}
              code={formData.countryCode}
              onChange={(fullValue, details) => {
                handleChange("contactNumber", details.number);
                handleChange("countryCode", details.countryCode);
                setErrors({
                  ...errors,
                  contactNumber: details.number
                    ? details?.error?.valid === true
                      ? ""
                      : "Mobile number invalid"
                    : "",
                });
              }}
              error={errors.contactNumber}
            />
            <FormFieldSet
              type="text"
              title="Alternate Email Address"
              placeholder="Enter Alternate Email Address"
              value={formData.alternateEmail}
              onChange={(value) => handleChange("alternateEmail", value)}
              error={errors.alternateEmail}
            />

            <FormFieldSet
              type="select"
              title="Gender"
              placeholder="Select Gender"
              value={formData.gender}
              onChange={(value) => handleChange("gender", value)}
              error={errors.gender}
              options={Gender}
            />
            <FormFieldSet
              type="text"
              title="Employee ID"
              placeholder="Enter Employee ID"
              value={formData.employeId}
              onChange={(value) => handleChange("employeId", value)}
              error={errors.employeId}
              disabled={true}
            />
            <FormFieldSet
              type="select"
              title="Employee Type"
              placeholder="Enter Employee Type"
              value={formData.employeeType}
              onChange={(value) => handleChange("employeeType", value)}
              error={errors.employeeType}
              options={EmploymentType}
            />
            <FormFieldSet
              type="select"
              title="Employee Status"
              placeholder="Select Employee Status"
              value={formData.employeeStatus}
              onChange={(value) => handleChange("employeeStatus", value)}
              error={errors.employeeStatus}
              options={EmployeeStatus}
            />
            <FormFieldSet
              type="select"
              title={"HR Manager"}
              keyname={"hiringManager"}
              placeholder="Select HR Manager"
              value={formData.hrManager}
              onChange={(value) => handleChange("hrManager", value)}
              options={hmOptions}
              showSearch
              searchValue={hiringManagerSearch}
              onSearch={handleHiringManagerSearch}
              onClose={resetHiringManagerSearch}
              error={errors.hrManager}
              icon={"add"}
              required
              refData={containerRef}
              handleScroll={() => handleHiringManagerScroll(containerRef)}
            />

            <FormFieldSet
              type="datepicker"
              title="Date Of Joining"
              placeholder="Select Date Of Joining"
              value={formData.dateOfJoining}
              onChange={(value) => handleChange("dateOfJoining", value)}
              error={errors.dateOfJoining}
              showDropdown={false}
            />
            <FormFieldSet
              type="select"
              title="Category"
              placeholder="select Category"
              value={formData.category}
              onChange={(value) => handleChange("category", value)}
              error={errors.category}
              options={[
                { value: "C2C", label: "C2C" },
                { value: "Full Time", label: "Full Time" },
                { value: "C2H", label: "C2H" },
                { value: "Referral", label: "Referral" },
                { value: "W2", label: "W2" },
                { value: "1099", label: "1099" },
              ]}
            />
            <FormFieldSet
              type="select"
              title="Location"
              placeholder="select Location"
              // value={formData.location}
              value={
                // formData.location ||
                `${formData?.location?.city || ""}, ${
                  formData?.location?.state || ""
                }` || ""
              }
              onChange={(value) => handleChange("location", value)}
              error={errors.location}
              options={cityStateListOptions}
            />
            <FormFieldSet
              type="select"
              title="Classification"
              placeholder="select Classification"
              value={formData.classification}
              onChange={(value) => handleChange("classification", value)}
              error={errors.classification}
              options={EmployeeClassification}
            />
            <FormFieldSet
              type="select"
              title="Work Authorization"
              placeholder="Select Work Authorization"
              value={formData.workAuthorization}
              onChange={(value) => handleChange("workAuthorization", value)}
              error={errors.workAuthorization}
              options={WADocType}
            />
          </div>
          <div className="flex gap-3 justify-end my-8">
            <Button
              title="Cancel"
              variant="outlined"
              onClick={handleModalClose}
            />
            <Button title="Save" onClick={() => handleSaveGeneralDetails()} />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditGeneralDetailsModal;
